<template>
  <div class="custom-select_analytics" :class="className">
    <div class="custom-select_icon">
      <!-- <img :src="selectIcon" alt="" /> -->
      <svg class="dropSvg">
        <use href="../../../assets//icons//arrow-down.svg#arrow-down"></use>
      </svg>
    </div>

    <select name="select_all" @change="onChange($event.target.value)">
      <option v-for="option in selectOptions" :key="option" :value="option">
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Object, required: true },
    fieldKey: {
      type: String,
      required: true,
    },
    className: {
      type: String,
    },
  },
  data() {
    return {
      newValue: "",
    };
  },
  computed: {
    selectOptions() {
      return Object.values(this.$props.options);
    },
    // selectIcon() {
    //   return require("@/assets/icons/Path.svg");
    // },
  },
  methods: {
    onChange(value) {
      this.$emit("change", {
        key: this.fieldKey,
        value: this.selectValue(value),
      });
    },
    selectValue(newValue) {
      return Object.entries(this.$props.options).find(
        ([key, value]) => value === newValue
      )[0];
    },
  },
};
</script>

<style>
.custom-select_analytics {
  width: 100%;
  position: relative;
}

.custom-select_analytics select {
  /* max-width: 100% !important; */
  outline: none;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  background: #fff;
  padding: 12px 16px 12px 20px;
  width: 100%;
  background-repeat: no-repeat;
  background-position: right 15px center;
  color: #4f4f4f;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.29;
  letter-spacing: -0.17px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  transition: all 150ms linear;
}

.custom-select_analytics select:focus-visible {
    border-color: rgb(49, 130, 206);
    box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
}

.custom-select_analytics select option {
  border-radius: 6px;
  transition: all ease-in-out 300ms;
}

svg.dropSvg {
  width: 14px;
  height: 8px;
  stroke: #3056d3;
  transition: all 150ms linear;
}

.custom-select_icon {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  height: 20px;
  width: 20px;
  overflow: hidden;
  border-radius: 50%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & img {
    width: 100%;
    height: 100%;
  }
}
</style>
